const actions = {
  PRODUCT_BATCH_CODE_LIST: 'PRODUCT_BATCH_CODE_LIST',
  PRODUCT_BATCH_CODE_LIST_ENDED: 'PRODUCT_BATCH_CODE_LIST_ENDED',
  CREATE_PRODUCT_BATCH_CODE: 'CREATE_PRODUCT_BATCH_CODE',
  CREATE_PRODUCT_BATCH_CODE_ENDED: 'CREATE_PRODUCT_BATCH_CODE_ENDED',
  PUT_PRODUCT_BATCH_CODE: 'PUT_PRODUCT_BATCH_CODE',
  PUT_PRODUCT_BATCH_CODE_ENDED: 'PUT_PRODUCT_BATCH_CODE_ENDED',
  DELETE_PRODUCT_BATCH_CODE: 'DELETE_PRODUCT_BATCH_CODE',
  DELETE_PRODUCT_BATCH_CODE_ENDED: 'DELETE_PRODUCT_BATCH_CODE_ENDED',
  PRODUCT_BATCH_CODE_INFO_LIST: 'PRODUCT_BATCH_CODE_INFO_LIST',
  PRODUCT_BATCH_CODE_INFO_LIST_ENDED: 'PRODUCT_BATCH_CODE_INFO_LIST_ENDED',
};

export default actions;
